import store from "@/store";
import { userCan } from "@/services/helpers";
import { makeListingRoutes } from "@/routes/marketplaceRoutes";

// Semi-public routes
// import externalServices from '@/pages/externalServices/ServicesMarkeplace.vue';

// Semi-public routes
// import externalServices from '@/pages/externalServices/ServicesMarkeplace.vue';
const ServicesMarkeplace = () => import("@/pages/externalServices/ServicesMarkeplace.vue");

// ***************************** Async Routes ****************************
// dev routes
const Kiosk = () => import("@/pages/kiosk/Kiosk.vue");

// general routes
const Main = () => import("@/layouts/Main.vue");
const SlashPage = () => import("@/layouts/SlashPage.vue");
const NotFound = () => import("@/pages/404.vue");
// const ComingSoon = () => import( '@/components/common/ComingSoon.vue');
const BrandOnboardCompanySelect = () => import("@/pages/onboardCompanySelect/BrandOnboardCompanySelect.vue");
const ChangeLog = () => import("@/pages/changeLog/ChangeLog.vue");
const PartnerAccount = () => import("@/pages/partner/PartnerAccount.vue");

// Reporting
const ReportingLanding = () => import("@/pages/reporting/ReportingLanding.vue");
const AdvancedReportingSellerOrders = () => import("@/pages/reporting/advanced/AdvancedReportingSellerOrders.vue");
const AdvancedReportingCurrentInventory = () => import("@/pages/reporting/advanced/AdvancedReportingCurrentInventory.vue");
const AdvancedReportingAllProductSales = () => import("@/pages/reporting/advanced/AdvancedReportingAllProductSales.vue");
const AdvancedReportingBuyerOrders = () => import("@/pages/reporting/advanced/AdvancedReportingBuyerOrders.vue");
const AdvancedReportingPayments = () => import("@/pages/reporting/advanced/AdvancedReportingPayments.vue");
const BasicReportingSellerOrders = () => import("@/pages/reporting/basic/BasicReportingSellerOrders.vue");
const BasicReportingBuyerOrders = () => import("@/pages/reporting/basic/BasicReportingBuyerOrders.vue");
const BasicReportingArAging = () => import("@/pages/reporting/basic/BasicReportingArAging.vue");
const BasicReportingProductSales = () => import("@/pages/reporting/basic/BasicReportingProductSales.vue");
const BasicReportingInventoryOverview = () => import("@/pages/reporting/basic/BasicReportingInventoryOverview.vue");
const BasicReportingBrandCompanyInventory = () => import("@/pages/reporting/basic/BasicReportingBrandCompanyInventory.vue");
const BasicReportingBrandCompanyOrders = () => import("@/pages/reporting/basic/BasicReportingBrandCompanyOrders.vue");
const PerformanceReportingProduct = () => import("@/pages/reporting/performance/PerformanceReportingProduct.vue");
const PerformanceReportingBuyer = () => import("@/pages/reporting/performance/PerformanceReportingBuyer.vue");
const BasicSellerSamplesReport = () => import("@/pages/reporting/basic/BasicSellerSamplesReport.vue");
const BasicSellerBrandsReport = () => import("@/pages/reporting/basic/BasicSellerBrandsReport.vue");
const PricingToolSavedQueries = () => import("@/pages/pricingTool/PricingToolSavedQueries.vue");
const PerformanceReportingRepSales = () => import("@/pages/reporting/performance/PerformanceReportingRepSales.vue");
const BasicReportingBuyerRecentOrders = () => import("@/pages/reporting/basic/BasicReportingBuyerRecentOrders.vue");
const AdvancedReportingAllProductPurchases = () => import("@/pages/reporting/advanced/AdvancedReportingAllProductPurchases.vue");
const ApexAi = () => import("@/pages/reporting/ApexAi.vue");
// Auth Routes
const ResetPassword = () => import("@/pages/auth/ResetPassword.vue");
const Auth = () => import("@/pages/auth/Auth.vue");
const VerifyEmail = () => import("@/pages/auth/VerifyEmail.vue");

// User Routes
const UserSettings = () => import("@/pages/userSettings/UserSettings.vue");
const Security = () => import("@/pages/security/Security.vue");
const Companies = () => import("@/pages/companies/Companies.vue");
const PlatformIq = () => import("@/pages/platformIq/PlatformIq.vue");
const Referral = () => import("@/pages/referral/Referral.vue");

// company routes
const CompanyProfile = () => import("@/pages/companyProfile/CompanyProfile.vue");
const CompanySettings = () => import("@/pages/companySettings/CompanySettings.vue");
const WholesaleNeeds = () => import("@/pages/wholesaleNeeds/WholesaleNeeds.vue");
const BuyerRequests = () => import("@/pages/buyerRequests/BuyerRequests.vue");
const CompanyIntegrations = () => import("@/pages/companyIntegrations/CompanyIntegrations.vue");
const Payments = () => import("@/pages/payments/Payments.vue");
const Account = () => import("@/pages/account/Account.vue");
const Events = () => import("@/pages/events/Events.vue");
const Rejects = () => import("@/pages/inventory/rejects/Rejects.vue");
const Tasks = () => import("@/pages/tasks/Tasks.vue");
const Operations = () => import("@/pages/operations/Operations.vue");
const Operation = () => import("@/pages/operation/Operation.vue");
const Orders = () => import("@/pages/orders/Orders.vue");
const SellerOrderBuilder = () => import("@/pages/orders/SellerOrderBuilder.vue");
const SellerOrderCart = () => import("@/pages/orders/SellerOrderCart.vue");
const ShippingOrder = () => import("@/pages/orders/shippingOrders/shippingOrder/ShippingOrder.vue");
const ReceivingOrder = () => import("@/pages/orders/receivingOrders/receivingOrder/ReceivingOrder.vue");
const Activity = () => import("@/pages/activity/Activity.vue");
const Buyers = () => import("@/pages/buyers/Buyers.vue");
const Buyer = () => import("@/pages/buyer/Buyer.vue");
const Vendors = () => import("@/pages/vendors/Vendors.vue");
const Vendor = () => import("@/pages/vendor/Vendor.vue");
const Brands = () => import("@/pages/brands/Brands.vue");
const BulkDiscounts = () => import("@/pages/bulkDiscounts/BulkDiscounts.vue");
const DealFlows = () => import("@/pages/dealFlows/DealFlows.vue");
const Users = () => import("@/pages/users/Users.vue");
const Inventory = () => import("@/pages/inventory/Inventory.vue");
const StockAlerts = () => import("@/pages/stockAlerts/StockAlerts.vue");
const MappedRetailers = () => import("@/pages/stockAlerts/MappedRetailers.vue");
const UnmappedRetailers = () => import("@/pages/stockAlerts/UnmappedRetailers.vue");

const CompanyServicesPrivate = () => import("@/pages/companyServices/CompanyServicesPrivate.vue");
const CompanyAlerts = () => import("@/pages/companyAlerts/CompanyAlerts.vue");
const CompanyChat = () => import("@/pages/companyChat/CompanyChat.vue");
const Messages = () => import("@/pages/messages/Messages.vue");
const BuyerNeeds = () => import("@/pages/buyerNeeds/BuyerNeeds.vue");
const Tags = () => import("@/pages/tags/Tags.vue");
const PublicInvoice = () => import("@/pages/publicInvoice/PublicInvoice.vue");
const BuyerSheetPortal = () => import("@/pages/buyerSheetPortal/BuyerSheetPortal.vue");
const SheetReviewQueue = () => import("@/pages/sheetUpload/SheetReviewQueue.vue");
const SupportLanding = () => import("@/pages/supportLanding/SupportLanding.vue");
const Feedback = () => import("@/pages/supportLanding/Feedback.vue");
const Support = () => import("@/pages/support/Support.vue");

const Awards = () => import("@/pages/awards/Awards.vue");
const Transporters = () => import("@/pages/transporters/Transporters.vue");
const ApiLandingPage = () => import("@/pages/companyApi/ApiLandingPage.vue");
const MyVendors = () => import("@/pages/myVendors/MyVendors.vue");
const CompanyServiceLeads = () => import("@/pages/companyServices/CompanyServiceLeads.vue");
const CompanyServiceLead = () => import("@/pages/companyServices/CompanyServiceLead.vue");
const NotAuthorized = () => import("@/pages/NotAuthorized.vue");
const MarketplaceCart = () => import("@/pages/marketplace/cart/Cart.vue");
const MarketplaceSearch = () => import("@/pages/marketplace/search/MarketplaceSearch.vue");
const VendorStorefront = () => import("@/pages/vendorStorefront/VendorStorefront.vue");
const ProductPage = () => import("@/pages/productPage/ProductPage.vue");
const ThreePLLeads = () => import("@/pages/3pl/3pl-leads.vue");
const ThreePLOrders = () => import("@/pages/3pl/3pl-orders.vue");
const BrandOrders = () => import("@/pages/brandOrders/brandOrders.vue");

const platform = APP_NAME;

const routes = [
  {
    path: "/login",
    alias: "/register",
    component: Auth,
    meta: { title: `${platform} - Login` },
    beforeEnter: (to, from) => {
      if (store.state.auth.loggedIn) {
        if (to.query && to.query["brand-invitation"]) {
          return { path: "/brand-onboard", query: to.query };
        } else {
          return { path: "/", query: { redirect: to.fullPath } };
        }
      } else {
        return;
      }
    },
  },
  {
    path: "/reset-password/:token",
    meta: { title: `${platform} - Reset Password` },
    component: ResetPassword,
  },
  {
    path: "/verify-email",
    meta: { title: `${platform} - Verify Email` },
    component: VerifyEmail,
    beforeEnter: (to, from) => {
      if (!store.state.auth.loggedIn) {
        return { path: "/login" };
      } else if (store.state.auth.user.email_verified_at) {
        return { path: "/" };
      } else {
        return;
      }
    },
  },
  {
    path: "/invoice/:anyrandomstring/:order_uuid", // this is temporary, old format. Can be removed after 9/1/22.
    meta: { title: `${platform} - Invoice` },
    component: PublicInvoice,
  },
  {
    path: "/invoice/:order_uuid",
    meta: { title: `${platform} - Invoice` },
    component: PublicInvoice,
  },
  {
    path: "/sheets/:seller_uuid",
    meta: { title: `${platform} - Order Sheet` },
    component: BuyerSheetPortal,
  },

  // protected routes
  {
    path: "/",
    component: Main,
    beforeEnter: (to, from) => {
      if (!store.state.auth.loggedIn) {
        return { path: "/login", query: { redirect: to.fullPath } };
      } else {
        return;
      }
    },
    children: [
      {
        path: "",
        meta: { title: `${platform}`, transition: "fade" },
        component: SlashPage,
        // /marketplace is no longer an alias — it has its own routes below so categories,
        // filters and sorting can live in the URL. MarketplaceSearch sends non-buyers home.
        alias: ["/dashboard", "/onboarding"],
      },
      {
        path: "/change-log",
        meta: { title: `${platform} - Change Log`, transition: "fade" },
        component: ChangeLog,
      },
      {
        path: "/partner",
        meta: { title: `${platform} - Partner`, transition: "fade" },
        component: PartnerAccount,
      },
      {
        path: "kiosk",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        // Deep link to a specific company inside the kiosk. Kiosk.vue reads
        // the id param and pre-opens that company's profile.
        name: "kiosk-company",
        path: "kiosk/companies/company/:id",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        // Deep link to a specific backlog github issue detail.
        name: "kiosk-backlog-item",
        path: "kiosk/backlog/:id",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        // Deep link to a specific support ticket detail.
        name: "kiosk-ticket",
        path: "kiosk/tickets/:id",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        // Deep link to a specific kiosk task detail.
        name: "kiosk-task",
        path: "kiosk/tasks/:id",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        // Deep link to a specific user profile in the kiosk.
        name: "kiosk-user",
        path: "kiosk/users/:id",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        // Deep link to a specific academy article (opens its edit modal).
        name: "kiosk-academy-article",
        path: "kiosk/academy/articles/:id",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        // Deep link to a specific academy category (opens its edit modal).
        name: "kiosk-academy-category",
        path: "kiosk/academy/categories/:id",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        name: "kiosk-data-management-tab",
        path: "kiosk/data-management/:tab",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        // Every kiosk sidebar item is deep-linkable via /kiosk/:section where
        // :section is a slug that maps to the display label in Kiosk.vue.
        path: "kiosk/:section",
        component: Kiosk,
        meta: { requiresAuth: true, title: `${platform} - Kiosk`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.kioskUser.id) {
            return { path: "/", query: { redirect: to.fullPath } };
          } else {
            return;
          }
        },
      },
      {
        path: "user-settings",
        component: UserSettings,
        meta: { requiresAuth: true, title: `${platform} - User Settings`, transition: "fade" },
      },
      {
        path: "companies",
        component: Companies,
        meta: { requiresAuth: true, title: `${platform} - My Companies`, transition: "fade" },
      },
      {
        path: "security",
        component: Security,
        meta: { requiresAuth: true, title: `${platform} - Security`, transition: "fade" },
      },
      {
        path: "platform-iq",
        component: PlatformIq,
        meta: { requiresAuth: true, title: `${platform} - ApexIQ`, transition: "fade" },
      },

      // support routes
      {
        path: "support",
        component: SupportLanding,
        meta: { requiresAuth: true, title: `${platform} - Support`, transition: "fade" },
      },
      {
        path: "feedback",
        component: Feedback,
        meta: { requiresAuth: true, title: `${platform} - Feedback`, transition: "fade" },
      },
      {
        path: "kb",
        component: Support,
        meta: { requiresAuth: true, title: `${platform} - Knowledge Base`, transition: "fade" },
      },

      {
        path: "kb/:category/",
        component: Support,
        meta: { requiresAuth: true, title: `${platform} - Knowledge Base`, transition: "fade" },
      },

      {
        path: "kb/:category/:article",
        component: Support,
        meta: { requiresAuth: true, title: `${platform} - Knowledge Base`, transition: "fade" },
      },

      // brand onboard
      {
        path: "brand-onboard",
        component: BrandOnboardCompanySelect,
        meta: { requiresAuth: true, title: `${platform} - Brand Onboard`, transition: "fade" },
      },

      // not authorized
      {
        path: "not-authorized",
        component: NotAuthorized,
        meta: { requiresAuth: true, title: `${platform} - Not Authorized`, transition: "fade" },
      },

      // marketplace cart
      {
        path: "marketplace/cart",
        component: MarketplaceCart,
        meta: { requiresAuth: true, title: `${platform} - Marketplace`, transition: "fade", hidePadding: true, pricingTool: true },
      },

      // Marketplace listing. The category/subcategory path segments and the product page come
      // from the shared factory so all three listing surfaces stay identical.
      //
      // marketplace/search is kept as an alias rather than a redirect: a string redirect drops
      // the query string, which would break the cart's "return to search" links.
      ...makeListingRoutes({
        basePath: "marketplace",
        namePrefix: "marketplace",
        listing: MarketplaceSearch,
        product: ProductPage,
        productPath: "product/:vendorSlug/:productSlug",
        meta: { requiresAuth: true, title: `${platform} - Marketplace`, transition: "fade", hidePadding: true, pricingTool: true },
      }).map((route) => (route.name === "marketplaceListing" ? { ...route, alias: ["/marketplace/search"] } : route)),

      // Company Routes
      {
        path: "inventory",
        component: Inventory,
        meta: { requiresAuth: true, title: `${platform} - Inventory`, transition: "fade", pricingTool: true },
        beforeEnter: (to, from) => {
          if (userCan("view inventory", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },

      {
        path: "stock-alerts",
        component: StockAlerts,
        meta: { requiresAuth: true, title: `${platform} - Stock Alerts` },

        children: [
          {
            path: "",
            component: MappedRetailers,
            meta: {
              requiresAuth: true,
              title: `${platform} - Wholesale Needs`,
            },
          },
          {
            path: "unmapped-retailers",
            component: UnmappedRetailers,
            meta: { requiresAuth: true, title: `${platform} - Buyer Needs` },
          },
        ],
      },
      {
        path: "company/account",
        component: Account,
        meta: { requiresAuth: true, title: `${platform} - Account`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("update company account", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/tags",
        component: Tags,
        meta: { requiresAuth: true, title: `${platform} - Tags`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("update tags", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/settings",
        component: CompanySettings,
        meta: { requiresAuth: true, title: `${platform} - Settings`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("update company settings", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/integrations",
        component: CompanyIntegrations,
        meta: { requiresAuth: true, title: `${platform} - Integrations`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan(["update company integrations", "use metrc features"], store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "events",
        component: Events,
        meta: { requiresAuth: true, title: `${platform} - Events`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("update events", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "rejects",
        component: Rejects,
        meta: { requiresAuth: true, title: `${platform} - Rejects`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("update rejects", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "tasks",
        component: Tasks,
        meta: { requiresAuth: true, title: `${platform} - Tasks`, transition: "fade" },
      },
      {
        path: "leads",
        component: Messages,
        meta: {
          requiresAuth: true,
          title: `${platform} - Leads`,
          transition: "fade",
        },
      },
      {
        path: "3pl/leads",
        component: ThreePLLeads,
        meta: {
          requiresAuth: true,
          title: `${platform} - Leads`,
          transition: "fade",
        },
      },
      {
        path: "3pl/orders",
        component: ThreePLOrders,
        meta: {
          requiresAuth: true,
          title: `${platform} - Orders`,
          transition: "fade",
        },
      },
      {
        path: "brand/orders",
        redirect: "/orders",
      },
      {
        name: "Chat",
        path: "chat",
        component: CompanyChat,
        meta: {
          requiresAuth: true,
          title: `${platform} - Chat`,
          transition: "fade",
        },
        props: true,
      },
      {
        path: "alerts",
        component: CompanyAlerts,
        meta: { requiresAuth: true, title: `${platform} - Alerts`, transition: "fade" },
      },
      {
        path: "reports",
        component: ReportingLanding,
        meta: { requiresAuth: true, title: `${platform} - Reports`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan(["view reports", "view buyer performance report sales rep", "use data assistant"], store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/apex-ai",
        component: ApexAi,
        meta: { requiresAuth: true, title: `${platform} - Apex AI`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.getters["auth/hasFeatureFlag"]("apex-ai") && userCan("use data assistant", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/seller-orders",
        component: AdvancedReportingSellerOrders,
        meta: {
          requiresAuth: true,
          title: `${platform} - Seller Order Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/ar-aging",
        component: BasicReportingArAging,
        meta: {
          requiresAuth: true,
          title: `${platform} - A/R Aging Report`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/payments",
        component: AdvancedReportingPayments,
        meta: {
          requiresAuth: true,
          title: `${platform} - Payments Report`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/current-inventory",
        component: AdvancedReportingCurrentInventory,
        meta: {
          requiresAuth: true,
          title: `${platform} - Current Inventory Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/all-product-sales",
        component: AdvancedReportingAllProductSales,
        meta: {
          requiresAuth: true,
          title: `${platform} - All Product Sales Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/buyer-orders",
        component: AdvancedReportingBuyerOrders,
        meta: {
          requiresAuth: true,
          title: `${platform} - Buyer Order Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (
            userCan("view reports", store.state.auth.user) &&
            (store.state.auth.user.current_company.subscription == "buyer" || store.state.auth.user.current_company.subscription == "seller")
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/buyer-recent-orders",
        component: BasicReportingBuyerRecentOrders,
        meta: {
          requiresAuth: true,
          title: `${platform} - Buyer Recent Orders Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "buyer") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/basic-seller-orders",
        component: BasicReportingSellerOrders,
        meta: {
          requiresAuth: true,
          title: `${platform} - Seller Order Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/basic-all-product-sales",
        component: BasicReportingProductSales,
        meta: {
          requiresAuth: true,
          title: `${platform} - All Product Sales Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/basic-buyer-orders",
        component: BasicReportingBuyerOrders,
        meta: {
          requiresAuth: true,
          title: `${platform} - Buyer Order Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (
            userCan("view reports", store.state.auth.user) &&
            (store.state.auth.user.current_company.subscription == "buyer" || store.state.auth.user.current_company.subscription == "seller")
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/inventory-overview",
        component: BasicReportingInventoryOverview,
        meta: {
          requiresAuth: true,
          title: `${platform} - Buyer Order Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/samples-report",
        component: BasicSellerSamplesReport,
        meta: {
          requiresAuth: true,
          title: `${platform} - Seller Order Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/pricing-tool",
        component: PricingToolSavedQueries,
        meta: {
          requiresAuth: true,
          title: `${platform} - Pricing Tool`,
          transition: "fade",
          pricingTool: true,
        },
        beforeEnter: (to) => {
          // A purchase refreshes the companies store, not the user's copy, which is the fallback
          // before the store has loaded.
          const config = store.getters["companies/currentCompany"]?.config ?? store.state.auth.user.current_company?.config;
          if (config?.can_use_pricing_tool && store.getters["auth/hasFeatureFlag"]("pricing-tool")) {
            return;
          }
          return { path: "/not-authorized", query: { redirect: to.fullPath } };
        },
      },
      {
        path: "reports/brands-report",
        component: BasicSellerBrandsReport,
        meta: {
          requiresAuth: true,
          title: `${platform} - Seller Brands Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/product-performance",
        component: PerformanceReportingProduct,
        meta: {
          requiresAuth: true,
          title: `${platform} - Buyer Order Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/buyer-performance",
        component: PerformanceReportingBuyer,
        meta: {
          requiresAuth: true,
          title: `${platform} - Buyer Performance Reports`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (
            userCan(["view reports", "view buyer performance report sales rep"], store.state.auth.user) &&
            store.state.auth.user.current_company.subscription == "seller"
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/team-sales",
        component: PerformanceReportingRepSales,
        meta: {
          requiresAuth: true,
          title: `${platform} - Sales Team Performance Report`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (userCan("view reports", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/brand-distributor-inventory",
        component: BasicReportingBrandCompanyInventory,
        meta: {
          requiresAuth: true,
          title: `${platform} - Brand Distributor Inventory`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (
            userCan("view reports", store.state.auth.user) &&
            (store.state.auth.user.current_company.is_brand || store.state.auth.user.current_company.subscription == "brand")
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/brand-distributor-orders",
        component: BasicReportingBrandCompanyOrders,
        meta: {
          requiresAuth: true,
          title: `${platform} - Brand Distributor Orders`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (
            userCan("view reports", store.state.auth.user) &&
            (store.state.auth.user.current_company.is_brand || store.state.auth.user.current_company.subscription == "brand")
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "reports/all-product-purchases",
        component: AdvancedReportingAllProductPurchases,
        meta: {
          requiresAuth: true,
          title: `${platform} - All Product Purchases`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (
            userCan("view reports", store.state.auth.user) &&
            (store.state.auth.user.current_company.subscription == "buyer" || store.state.auth.user.current_company.subscription == "seller")
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/payments",
        component: Payments,
        meta: { requiresAuth: true, title: `${platform} - Payments`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("update payment settings", store.state.auth.user) && store.state.auth.user.current_company.subscription != "service provider") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/brands",
        component: Brands,
        meta: { requiresAuth: true, title: `${platform} - Brands`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/awards",
        component: Awards,
        meta: { requiresAuth: true, title: `${platform} - Awards`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/profile",
        component: CompanyProfile,
        meta: { requiresAuth: true, title: `${platform} - Company Profile`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("view company profile", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },

      {
        path: "company/users",
        component: Users,
        meta: { requiresAuth: true, title: `${platform} - Users`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("update users", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/deal-flows",
        component: DealFlows,
        meta: { requiresAuth: true, title: `${platform} - Deal Flows`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("update deal flows", store.state.auth.user) && store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/bulk-discounts",
        component: BulkDiscounts,
        meta: { requiresAuth: true, title: `${platform} - Bulk Discounts`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/operations",
        component: Operations,
        meta: { requiresAuth: true, title: `${platform} - Operations`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("view company operations", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/operations/operation/:uuid",
        component: Operation,
        meta: { requiresAuth: true, title: `${platform} - Operation`, transition: "fade" },
        props: true,
        beforeEnter: (to, from) => {
          if (userCan("view company operations", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        name: "ApiLandingPage",
        path: "company/api",
        component: ApiLandingPage,
        meta: { requiresAuth: true, title: `${platform} - API`, transition: "fade" },
        props: true,
        beforeEnter: (to, from) => {
          if (userCan(["manage api tokens", "view api tokens"], store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "wholesale-needs",
        component: WholesaleNeeds,
        meta: { requiresAuth: true, title: `${platform} - Wholesale Needs`, transition: "fade" },

        children: [
          {
            path: "",
            component: BuyerRequests,
            meta: {
              requiresAuth: true,
              title: `${platform} - Wholesale Needs`,
              transition: "fade",
            },
          },
          {
            path: "buyer-needs",
            component: BuyerNeeds,
            meta: { requiresAuth: true, title: `${platform} - Buyer Needs`, transition: "fade" },
          },
        ],
      },
      {
        path: "orders",
        component: Orders,
        props: true,
        meta: { requiresAuth: true, title: `${platform} - Orders`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (
            userCan(["view received orders", "view own orders", "view all orders"], store.state.auth.user) &&
            store.state.auth.user.current_company.subscription != "service provider"
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        name: "SheetReviewQueue",
        path: "orders/sheet-submissions",
        component: SheetReviewQueue,
        meta: { requiresAuth: true, title: `${platform} - Sheet Order Submissions`, transition: "fade" },
        beforeEnter: (to, from, next) => {
          if (
            userCan(["view own orders", "view all orders"], store.state.auth.user) &&
            store.state.auth.user.current_company.subscription == "seller"
          ) {
            next();
          } else {
            next({ path: "/not-authorized", query: { redirect: to.fullPath } });
          }
        },
      },
      {
        name: "SellerOrderCart",
        path: "orders/new/:buyerSlug/cart",
        component: SellerOrderCart,
        props: true,
        meta: { requiresAuth: true, title: `${platform} - Order Cart`, transition: "fade", hidePadding: true },
        beforeEnter: (to, from) => {
          if (
            userCan(["view own orders", "view all orders"], store.state.auth.user) &&
            ["seller", "brand"].includes(store.state.auth.user.current_company.subscription)
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        name: "SellerOrderBuilder",
        path: "orders/new/:buyerSlug",
        component: SellerOrderBuilder,
        props: true,
        meta: { requiresAuth: true, title: `${platform} - Order Builder`, transition: "fade", hidePadding: true },
        beforeEnter: (to, from) => {
          if (
            userCan(["view own orders", "view all orders"], store.state.auth.user) &&
            ["seller", "brand"].includes(store.state.auth.user.current_company.subscription)
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        name: "ReceivingOrder",
        path: "orders/receiving/:uuid",
        component: ReceivingOrder,
        props: true,
        meta: { requiresAuth: true, title: `${platform} - Orders`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan(["view received orders"], store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        name: "ShippingOrder",
        path: "orders/shipping/:uuid",
        component: ShippingOrder,
        props: true,
        meta: { requiresAuth: true, title: `${platform} - Orders`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan(["view own orders", "view all orders"], store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "buyers",
        component: Buyers,
        meta: { requiresAuth: true, title: `${platform} - Buyers`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        name: "Buyer",
        path: "buyers/buyer/:uuid",
        component: Buyer,
        meta: { requiresAuth: true, title: `${platform} - Buyer`, transition: "fade" },
        props: (route) => ({ uuid: route.params.uuid, startingTab: route.query.startingTab, buyerContactId: route.query.buyerContactId }),
        beforeEnter: (to, from) => {
          if (store.state.auth.user.current_company.subscription == "seller") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/activity",
        component: Activity,
        meta: { requiresAuth: true, title: `${platform} - Activity`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("view activity audit", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "company/transporters",
        component: Transporters,
        meta: { requiresAuth: true, title: `${platform} - Activity`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("update transporters", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        path: "vendors",
        component: Vendors,
        meta: { requiresAuth: true, title: `${platform} - Vendors`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("view vendors", store.state.auth.user) && store.state.auth.user.current_company.subscription != "service provider") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
        children: [
          {
            path: "",
            name: "MyVendors",
            component: MyVendors,
            meta: { requiresAuth: true, title: `${platform} - My Vendors`, transition: "fade" },
            beforeEnter: (to, from) => {
              if (userCan("view vendors", store.state.auth.user)) {
                return;
              } else {
                return {
                  path: "/not-authorized",
                  query: { redirect: to.fullPath },
                };
              }
            },
          },
          {
            path: "referral",
            component: Referral,
            name: "Referral",
            meta: { requiresAuth: true, title: `${platform} - Refer a Vendor`, transition: "fade" },
          },
        ],
      },
      {
        path: "vendors/vendor/:uuid",
        component: Vendor,
        meta: { requiresAuth: true, title: `${platform} - Vendor`, transition: "fade" },
        props: true,
        beforeEnter: (to, from) => {
          if (userCan("view vendors", store.state.auth.user) && store.state.auth.user.current_company.subscription != "service provider") {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      // Declared before the listing block so the static "cart" segment reads as taking
      // precedence over :category (vue-router ranks static above param regardless of order).
      // filterUrl's RESERVED_PATH_SEGMENTS covers the converse, keeping a category slugged
      // "cart" out of the path form.
      {
        path: "vendors/:vendorSlug/cart",
        component: MarketplaceCart,
        meta: { requiresAuth: true, title: `${platform} - Vendor Cart`, transition: "fade", hidePadding: true },
        props: true,
      },
      ...makeListingRoutes({
        basePath: "vendors/:vendorSlug",
        namePrefix: "vendorStorefront",
        listing: VendorStorefront,
        product: ProductPage,
        meta: { requiresAuth: true, title: `${platform} - Vendor Storefront`, transition: "fade", hidePadding: true },
      }),
      {
        name: "CompanyServiceLeads",
        path: "service-leads",
        component: CompanyServiceLeads,
        props: true,
        meta: {
          requiresAuth: true,
          title: `${platform} - Service Leads`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (
            userCan("view company services", store.state.auth.user) &&
            store.state.auth.user.current_company.subscription != "buyer" &&
            (store.state.auth.user.current_company.subscription == "service provider" ||
              (store.state.auth.user &&
                store.state.auth.user.current_company &&
                store.state.auth.user.current_company.config &&
                store.state.auth.user.current_company.config.can_be_service_provider) ||
              (store.getters["companies/currentCompany"].config && store.getters["companies/currentCompany"].config.can_be_service_provider))
          ) {
            return;
          } else {
            return { path: "/", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        name: "CompanyServiceLead",
        path: "service-leads/:uuid",
        component: CompanyServiceLead,
        props: (route) => ({ uuid: route.params.uuid, previousRoute: route.query.previousRoute }),
        meta: {
          requiresAuth: true,
          title: `${platform} - Service Lead`,
          transition: "fade",
        },
        beforeEnter: (to, from) => {
          if (
            userCan("view company services", store.state.auth.user) &&
            store.state.auth.user.current_company.subscription != "buyer" &&
            (store.state.auth.user.current_company.subscription == "service provider" ||
              (store.state.auth.user &&
                store.state.auth.user.current_company &&
                store.state.auth.user.current_company.config &&
                store.state.auth.user.current_company.config.can_be_service_provider) ||
              (store.getters["companies/currentCompany"].config && store.getters["companies/currentCompany"].config.can_be_service_provider))
          ) {
            return;
          } else {
            return { path: "/", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        name: "CompanyServices",
        path: "company-services",
        component: CompanyServicesPrivate,
        props: true,
        meta: { requiresAuth: true, title: `${platform} - Your Services`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (
            userCan("view company services", store.state.auth.user) &&
            (store.state.auth.user.current_company.subscription != "service provider" ||
              store.state.auth.user.current_company.subscription != "seller")
          ) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      {
        name: "ServicesMarkeplace",
        path: "services",
        component: ServicesMarkeplace,
        props: true,
        meta: { requiresAuth: true, title: `${platform} - Services`, transition: "fade" },
        beforeEnter: (to, from) => {
          if (userCan("view external services", store.state.auth.user)) {
            return;
          } else {
            return { path: "/not-authorized", query: { redirect: to.fullPath } };
          }
        },
      },
      { path: "*", component: NotFound, meta: { requiresAuth: true } }, // if not logged in, any route will redirect to login. if logged in, catch and show 404
    ],
  },
];

export default routes;
